import { Guardian } from '@xaamin/guardian';

Guardian.define('timbrado.sftp.reenviar.xml', (user) => {
  return user.can('timbrado.sftp.reenviar.xml');
});

Guardian.define('timbrado.sftp.listar.archivos', (user) => {
  return user.can('timbrado.sftp.listar.archivos');
});

Guardian.define('timbrado.sftp.descargar.archivos.procesados', (user) => {
  return user.can('timbrado.sftp.descargar.archivos.procesados');
});

Guardian.define('timbrado.sftp.descargar.archivo.original', (user) => {
  return user.can('timbrado.sftp.descargar.archivo.original');
});

Guardian.define('timbrado.sftp.reintentar.timbrado', (user) => {
  return user.can('timbrado.sftp.reintentar.timbrado');
});
